export const routeConfig = {
  meta: {
    title: '融资查询',
  },
};
